export class UsefulContactsVM {
    content: string = '';
    isLoading = false;
}
